import React from "react";

const TermsAndConditions = () => {
  return (
    <div className="ct_policy_page">
      <div className="ct_policy_container">
        <div className="ct_policy_header">
          <div style={{ marginBottom: "20px" }}>
            <img src="/img/Logo_blue_new.png" alt="First Mate Logo" style={{ height: "70px", objectFit: "contain" }} />
          </div>
          <h1 className="ct_policy_title">SOFTWARE SERVICES AGREEMENT</h1>
          <p className="ct_policy_meta">
            Terms &amp; Conditions · Version 1.0 · Effective Date: 14/07/2026
          </p>
          <div style={{ fontSize: "13px", color: "#64748b", marginTop: "5px" }}>
            <strong>Issued By:</strong> First Mate Pty Ltd (ABN: 52 662 331 713), Queensland, Australia
          </div>
        </div>
        <div className="ct_policy_content">
          <p>
            This Software Services Agreement ("Agreement") governs the use of the Servicehub software platform provided by First Mate Pty Ltd ("First Mate", "we", "our", "us").
          </p>
          <p>
            By registering for, accessing, or using Servicehub, the Provider agrees to be bound by the terms of this Agreement.
          </p>

          <h3>1. DEFINITIONS</h3>
          <p>In this Agreement:</p>
          <p><strong>Agreement</strong> means this Software Services Agreement including all schedules and policies incorporated by reference.</p>
          <p><strong>Customer</strong> means any vessel owner, operator, organisation, fleet manager, or end-user receiving services from the Provider.</p>
          <p><strong>Data</strong> means all information, records, documents, photographs, service histories, maintenance logs, warranty information and other content entered into the Platform.</p>
          <p><strong>Platform</strong> means the Servicehub software platform and associated applications, websites, APIs, integrations and services.</p>
          <p><strong>Provider</strong> means the business entity subscribing to and using Servicehub.</p>
          <p><strong>Subscription</strong> means the paid access plan selected by the Provider.</p>
          <p><strong>User</strong> means any authorised employee, contractor or representative of the Provider using the Platform.</p>

          <h3>2. PURPOSE</h3>
          <p>Servicehub is a cloud-based service management platform designed to assist Providers with:</p>
          <ul>
            <li>Job management</li>
            <li>Maintenance scheduling</li>
            <li>Service recording</li>
            <li>Warranty administration</li>
            <li>Customer communication</li>
            <li>Asset management</li>
            <li>Digital service histories</li>
            <li>Integration with the First Mate ecosystem</li>
          </ul>

          <h3>3. GRANT OF LICENCE</h3>
          <p>Subject to compliance with this Agreement and payment of applicable fees, First Mate grants the Provider a limited, non-exclusive, non-transferable, revocable licence to access and use Servicehub.</p>
          <p>The Provider may only use the Platform for legitimate business purposes.</p>
          <p>The Provider must not:</p>
          <ul>
            <li>Reverse engineer the Platform;</li>
            <li>Copy or reproduce the software;</li>
            <li>Attempt to access source code;</li>
            <li>Resell or sublicense the Platform;</li>
            <li>Circumvent subscription controls or security measures.</li>
          </ul>

          <h3>4. SUBSCRIPTION FEES</h3>
          <p>The Provider agrees to pay all fees applicable to its Subscription Plan.</p>
          <p>Subscription fees:</p>
          <ul>
            <li>Are payable in advance;</li>
            <li>Are non-refundable except where required by law;</li>
            <li>May be amended by First Mate with not less than thirty (30) days written notice.</li>
          </ul>
          <p>Failure to pay fees may result in:</p>
          <ul>
            <li>Suspension of access;</li>
            <li>Restriction of features;</li>
            <li>Termination of the Subscription.</li>
          </ul>
          <p>All fees stated in this Agreement are exclusive of goods and services tax (GST). Where GST is payable on any taxable supply made under this Agreement, the Provider must pay to First Mate an additional amount equal to the applicable GST, subject to receipt of a valid tax invoice.</p>
          <p>Fees are payable within fourteen (14) days of the date of invoice. Overdue amounts accrue interest at the rate of ten percent (10%) per annum, calculated daily from the due date until the date of actual payment.</p>

          <h3>5. USER ACCOUNTS</h3>
          <p>The Provider is responsible for:</p>
          <ul>
            <li>Maintaining account security;</li>
            <li>Restricting access to authorised users;</li>
            <li>Ensuring login credentials remain confidential;</li>
            <li>All activity conducted through its account.</li>
          </ul>
          <p>The Provider must immediately notify First Mate of any unauthorised access.</p>

          <h3>6. PROVIDER DATA</h3>
          <p>The Provider retains ownership of all Provider Data uploaded into the Platform.</p>
          <p>The Provider grants First Mate a non-exclusive licence to:</p>
          <ul>
            <li>Host;</li>
            <li>Process;</li>
            <li>Store;</li>
            <li>Backup;</li>
            <li>Display;</li>
            <li>Transmit;</li>
          </ul>
          <p>Provider Data solely for the purpose of delivering the Servicehub service.</p>

          <h3>7. SERVICE RECORDS AND DIGITAL LOGBOOKS</h3>
          <p>Servicehub enables Providers to create and maintain digital service histories.</p>
          <p>The Provider acknowledges that:</p>
          <ul>
            <li>Service records entered into Servicehub may be shared with vessel owners through approved integrations;</li>
            <li>Service records may form part of a vessel's digital maintenance history;</li>
            <li>Service records may be relied upon by customers when assessing maintenance and warranty status.</li>
          </ul>
          <p>The Provider remains solely responsible for the accuracy and completeness of all service records.</p>
          <p>First Mate does not verify the accuracy or completeness of any information entered into the Platform by the Provider or its Users and accepts no liability for any reliance placed by any third party on service records or digital logbook entries stored on the Platform.</p>

          <h3>8. FIRST MATE INTEGRATION</h3>
          <p>Where the Provider elects to participate in the First Mate ecosystem, the Provider authorises Servicehub to share approved information with connected vessel owners.</p>
          <p>Such information may include:</p>
          <ul>
            <li>Maintenance records;</li>
            <li>Service schedules;</li>
            <li>Warranty information;</li>
            <li>Inspection reports;</li>
            <li>Asset records;</li>
            <li>Service reminders.</li>
          </ul>
          <p>The Provider warrants that all information shared is accurate to the best of its knowledge.</p>

          <h3>9. MAINTENANCE REQUESTS</h3>
          <p>Where a customer submits a Maintenance Request through the First Mate application:</p>
          <ul>
            <li>Servicehub may automatically create a record within the Platform;</li>
            <li>The Provider remains responsible for determining whether work is accepted;</li>
            <li>First Mate does not guarantee the accuracy of information submitted by customers.</li>
          </ul>

          <h3>10. WARRANTY CLAIM REQUESTS</h3>
          <p>Where customers submit Warranty Requests through connected applications:</p>
          <ul>
            <li>The Provider remains responsible for assessing warranty eligibility;</li>
            <li>First Mate does not determine warranty outcomes;</li>
            <li>Servicehub acts solely as an information management platform.</li>
          </ul>

          <h3>11. PLATFORM AVAILABILITY</h3>
          <p>First Mate will use reasonable efforts to maintain Platform availability.</p>
          <p>However, First Mate does not guarantee:</p>
          <ul>
            <li>Continuous availability;</li>
            <li>Uninterrupted access;</li>
            <li>Error-free operation;</li>
            <li>Compatibility with all devices or third-party systems.</li>
          </ul>
          <p>Scheduled maintenance may occur periodically.</p>

          <h3>12. SUPPORT SERVICES</h3>
          <p>Support services may include:</p>
          <ul>
            <li>Email support;</li>
            <li>Online resources;</li>
            <li>System updates;</li>
            <li>Bug fixes.</li>
          </ul>
          <p>Support response times are provided on a reasonable efforts basis unless otherwise agreed.</p>

          <h3>13. ACCEPTABLE USE</h3>
          <p>The Provider must not:</p>
          <ul>
            <li>Upload unlawful material;</li>
            <li>Infringe intellectual property rights;</li>
            <li>Upload malware or malicious code;</li>
            <li>Use the Platform fraudulently;</li>
            <li>Attempt unauthorised access;</li>
            <li>Use the Platform in a manner likely to damage First Mate's reputation.</li>
          </ul>
          <p>First Mate may suspend accounts that breach this clause.</p>

          <h3>14. CONFIDENTIALITY</h3>
          <p>Each party must keep confidential all non-public information obtained from the other party.</p>
          <p>Confidential information must not be disclosed except:</p>
          <ul>
            <li>With written consent;</li>
            <li>Where required by law;</li>
            <li>To professional advisers under confidentiality obligations.</li>
          </ul>

          <h3>15. PRIVACY</h3>
          <p>Each party agrees to comply with applicable privacy legislation.</p>
          <p>The Provider is responsible for obtaining all necessary customer consents for the collection and processing of personal information through Servicehub.</p>
          <p>First Mate will implement and maintain reasonable technical and organisational measures to protect Provider Data against unauthorised access, disclosure, loss or destruction, commensurate with the nature of the data held.</p>
          <p>In the event of a confirmed data breach affecting Provider Data, First Mate will notify the Provider as soon as reasonably practicable and, where required by the Privacy Act 1988 (Cth), will comply with its notifiable data breach obligations to the Office of the Australian Information Commissioner.</p>
          <p>The Provider acknowledges that First Mate’s collection and handling of personal information is further governed by First Mate’s Privacy Policy, which is incorporated into this Agreement by reference.</p>

          <h3>16. INTELLECTUAL PROPERTY</h3>
          <p>All intellectual property rights relating to Servicehub remain the exclusive property of First Mate Pty Ltd.</p>
          <p>Nothing in this Agreement transfers ownership of:</p>
          <ul>
            <li>Software;</li>
            <li>Trademarks;</li>
            <li>Branding;</li>
            <li>Source code;</li>
            <li>Databases;</li>
            <li>Workflows;</li>
            <li>Documentation.</li>
          </ul>

          <h3>17. MARKETING RIGHTS</h3>
          <p>The Provider grants First Mate the right to identify the Provider by name as a customer of Servicehub, solely for factual identification purposes (including on First Mate’s website and in marketing materials). First Mate will not use the Provider’s name, logo or branding in a manner that implies endorsement without the Provider’s prior written consent.</p>
          <p>No confidential information will be disclosed without consent.</p>

          <h3>18. LIMITATION OF LIABILITY</h3>
          <p>To the maximum extent permitted by law:</p>
          <p>First Mate shall not be liable for:</p>
          <ul>
            <li>Loss of profits;</li>
            <li>Loss of business opportunities;</li>
            <li>Indirect loss;</li>
            <li>Consequential loss;</li>
            <li>Loss arising from inaccurate information entered by users.</li>
          </ul>
          <p>The aggregate liability of First Mate shall not exceed the subscription fees paid by the Provider during the twelve (12) months preceding the event giving rise to the claim.</p>
          <p>Nothing in this clause limits, excludes or modifies any guarantee, condition, warranty, right or remedy that cannot lawfully be excluded or limited under the Australian Consumer Law (Schedule 2 of the Competition and Consumer Act 2010 (Cth)) or any other applicable legislation.</p>

          <h3>19. INDEMNITY</h3>
          <p>The Provider indemnifies First Mate against all claims, losses, liabilities, costs and expenses arising from:</p>
          <ul>
            <li>Incorrect service records;</li>
            <li>Warranty disputes;</li>
            <li>Customer disputes;</li>
            <li>Regulatory breaches;</li>
            <li>Misuse of the Platform.</li>
          </ul>
          <p>The indemnity in this clause does not apply to the extent that a claim, loss, liability, cost or expense is directly caused by First Mate’s own negligence, wilful misconduct or material breach of this Agreement.</p>

          <h3>20. TERMINATION</h3>
          <p>Either party may terminate this Agreement by providing not less than thirty (30) days’ prior written notice to the other party.</p>
          <p>First Mate may immediately suspend or terminate access where:</p>
          <ul>
            <li>Fees remain unpaid;</li>
            <li>The Provider breaches this Agreement;</li>
            <li>Fraudulent or unlawful conduct occurs.</li>
          </ul>

          <h3>21. DATA RETENTION</h3>
          <p>Upon termination:</p>
          <ul>
            <li>Provider Data will remain available for thirty (30) days;</li>
            <li>Providers may export their records during this period;</li>
            <li>Data may thereafter be archived or deleted.</li>
          </ul>
          <p>First Mate may retain records where legally required.</p>

          <h3>22. FUTURE FEATURES</h3>
          <p>First Mate may modify or enhance features of the Platform from time to time. Where First Mate proposes to discontinue a material feature of the Platform, First Mate will use reasonable efforts to provide the Provider with not less than thirty (30) days’ prior written notice of such discontinuation.</p>
          <p>Nothing in this Agreement guarantees the release of future functionality.</p>

          <h3>23. GOVERNING LAW</h3>
          <p>This Agreement shall be governed by and construed in accordance with the laws of Queensland, Australia.</p>
          <p>The parties submit to the exclusive jurisdiction of the courts of Queensland.</p>

          <h3>24. DISPUTE RESOLUTION</h3>
          <p>If a dispute arises out of or in connection with this Agreement, the parties must follow the process set out in this clause before commencing legal proceedings (except where a party seeks urgent interlocutory relief).</p>
          <p>A party claiming a dispute exists must provide written notice to the other party specifying the nature of the dispute and the outcome sought.</p>
          <p>Within fourteen (14) days of the notice, senior representatives of each party must meet (in person, by telephone or by video conference) and negotiate in good faith to resolve the dispute.</p>
          <p>If the dispute is not resolved within fourteen (14) days of the meeting (or such further period as the parties agree in writing), either party may refer the dispute to mediation administered by the Resolution Institute or such other mediator as the parties agree.</p>
          <p>If mediation does not resolve the dispute within thirty (30) days of referral (or such extended period as the parties agree), either party may commence legal proceedings in accordance with clause 23.</p>

          <h3>25. FORCE MAJEURE</h3>
          <p>First Mate will not be liable for any failure or delay in performing its obligations under this Agreement to the extent caused by an event beyond First Mate’s reasonable control, including fire, flood, earthquake, pandemic, acts of government, failure of third-party infrastructure or internet service providers, or cyber attacks (each a Force Majeure Event).</p>
          <p>First Mate will notify the Provider as soon as reasonably practicable upon becoming aware of a Force Majeure Event affecting its ability to perform and will use reasonable endeavours to minimise the impact on service delivery. If a Force Majeure Event continues for more than sixty (60) consecutive days, either party may terminate this Agreement on written notice without liability.</p>

          <h3>ACCEPTANCE</h3>
          <p>By creating an account, accessing the Platform or continuing to use Servicehub, the Provider acknowledges that it has read, understood and agreed to be bound by this Agreement.</p>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;
